import type { StandoutNotation } from "@libertify/ui";
import type { StrokedNotation } from "./types";

/** Translation key prefix for the Standouts edit card. */
export const KEY = "experienceEdit.standoutsCard";

/** Marker types a row offers, in the mock's order. */
export const NOTATION_PILLS = [
  "highlight",
  "underline",
  "circle",
  "box",
] as const satisfies readonly StandoutNotation[];

/** Never drawn: every standout mark brings its own marker color. */
export const UNUSED_SOURCE_COLOR = "#000000";

/**
 * The style popover's colors, from the mock. Softer than the marker palette so
 * a custom pick can't end up loud. Names are translation key suffixes.
 */
export const STYLE_COLORS = [
  { name: "amber", value: "#C99A4A" },
  { name: "coral", value: "#C97B6E" },
  { name: "indigo", value: "#7B7ED9" },
  { name: "emerald", value: "#5FAE8C" },
  { name: "slate", value: "#8B93A6" },
  { name: "rose", value: "#C97FA0" },
] as const;

/** `stroke_width` per thickness. Regular is the palette's own stroke. */
export const THICKNESS_PRESETS = [
  { name: "thin", value: 1 },
  { name: "regular", value: 2 },
  { name: "bold", value: 3 },
] as const;

/**
 * `padding` per type, scaled off the palette's own default so Normal draws
 * exactly what an unstyled standout draws today.
 */
export const PADDING_PRESETS: Record<
  StrokedNotation,
  readonly { name: "tight" | "normal" | "loose"; value: number }[]
> = {
  underline: [
    { name: "tight", value: 1 },
    { name: "normal", value: 3 },
    { name: "loose", value: 5 },
  ],
  circle: [
    { name: "tight", value: 5 },
    { name: "normal", value: 10 },
    { name: "loose", value: 16 },
  ],
  box: [
    { name: "tight", value: 4 },
    { name: "normal", value: 8 },
    { name: "loose", value: 12 },
  ],
};

/** A title made from a selection is cut to this many characters, plus "…". */
export const MAX_SELECTION_TITLE_LENGTH = 80;
